import _ from 'lodash';
import { URI } from '@fiverr-private/futile/lib/url';
import removeEmptyEntries from '../../../shared/utils/removeEmptyEntries';
import { clearActiveDefaults } from '../utils/filter_builder/selected_handlers';
import { activeFiltersToQueryString } from '../utils/filter_builder';
import { BI_SOURCES, EVENTS_MAPPING } from '../utils/constants';
import tracker from './tracker';

export const shouldFilterNavigate = (change, activeFilters) => {
    const combinedFilters = removeEmptyEntries({
        ...activeFilters,
        ...clearActiveDefaults(change)
    });

    return !_.isEqual(activeFilters, combinedFilters);
};

export const filterUrl = (change, activeFilters, source) => {
    if (!_isClient()) {
        return EMPTY_STRING;
    }

    const combinedFilters = removeEmptyEntries({
        ...activeFilters,
        ...clearActiveDefaults(change)
    });

    const uri = new URI(window.location.href);
    uri.removeParams('page');

    if (source) {
        uri.addParams({ source });
    }

    const ref = activeFiltersToQueryString(combinedFilters);
    ref === '' ? uri.removeParams('ref') : uri.addParams({ ref });

    return uri.toString();
};

export const filterNavigation = (change, activeFilters, location, source) => {
    const navigationUrl = filterUrl(change, activeFilters, source);

    Object.keys(change).forEach((filterId) => {
        tracker.seoFilterTrackingUpdate(activeFilters, change, location, filterId);
    });

    window.location.href = navigationUrl;
};

export const clearFiltersUrl = () => {
    if (!_isClient()) {
        return EMPTY_STRING;
    }

    const uri = new URI(window.location.href);
    uri.removeParams('page', 'ref', 'source');

    return uri.toString();
};

export const shouldSortNavigate = (change, current) => {
    if (!change) {
        return false;
    }

    const newValue = change['sort-by'];
    const prev = current.find(({ id }) => id === newValue);

    if (!prev) {
        return false;
    }

    const wasAlreadySelected = prev.selected;

    return !wasAlreadySelected;
};

export const sortNavigation = (change) => {
    if (!_isClient()) {
        return EMPTY_STRING;
    }
    const filter = change['sort-by'];

    const uri = new URI(window.location.href);
    uri.removeParams('page');
    uri.addParams({ source: BI_SOURCES.SORTING_BY });
    uri.addParams({ filter });

    tracker.track(EVENTS_MAPPING.SORT_CHANGE, { 'Sort': filter });
    window.location.href = uri.toString();
};

export const paginationUrl = (page) => {
    if (!_isClient()) {
        return EMPTY_STRING;
    }
    const uri = new URI(window.location.href);
    page === 1 ? uri.removeParams('page') : uri.addParams({ page });

    return uri.toString();
};

const EMPTY_STRING = '';
const _isClient = () => window && window.location;
